window.WALLPAPER_GALLERY_DATA = [
  {
    "title": "Cemento",
    "count": 64,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-cemento_1600x.webp?v=1783086868",
    "items": [
      {
        "title": "Cemento 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0001_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0001_320x.jpg?v=1783086873"
      },
      {
        "title": "Cemento 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0002_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0002_320x.jpg?v=1783086872"
      },
      {
        "title": "Cemento 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0003_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0003_320x.jpg?v=1783086873"
      },
      {
        "title": "Cemento 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0004_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0004_320x.jpg?v=1783086873"
      },
      {
        "title": "Cemento 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0005_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0005_320x.jpg?v=1783086873"
      },
      {
        "title": "Cemento 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0006_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0006_320x.jpg?v=1783086873"
      },
      {
        "title": "Cemento 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0007_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0007_320x.jpg?v=1783086873"
      },
      {
        "title": "Cemento 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0008_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0008_320x.jpg?v=1783086873"
      },
      {
        "title": "Cemento 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0009_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0009_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0010_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0010_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0011_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0011_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0012_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0012_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0013_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0013_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0014_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0014_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0015_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0015_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0016_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0016_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0017_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0017_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0018_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0018_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0019_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0019_320x.jpg?v=1783086874"
      },
      {
        "title": "Cemento 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0020_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0020_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0021_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0021_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0022_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0022_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0023_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0023_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0024_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0024_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0025_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0025_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0026_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0026_320x.jpg?v=1783086875"
      },
      {
        "title": "Cemento 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0027_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0027_320x.jpg?v=1783086876"
      },
      {
        "title": "Cemento 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0028_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0028_320x.jpg?v=1783086876"
      },
      {
        "title": "Cemento 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0029_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0029_320x.jpg?v=1783086876"
      },
      {
        "title": "Cemento 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0030_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0030_320x.jpg?v=1783086876"
      },
      {
        "title": "Cemento 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0031_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0031_320x.jpg?v=1783086876"
      },
      {
        "title": "Cemento 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0032_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0032_320x.jpg?v=1783086876"
      },
      {
        "title": "Cemento 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0033_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0033_320x.jpg?v=1783086876"
      },
      {
        "title": "Cemento 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0034_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0034_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0035_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0035_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0036_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0036_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0037_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0037_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0038_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0038_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0039_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0039_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0040_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0040_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0041_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0041_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0042_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0042_320x.jpg?v=1783086877"
      },
      {
        "title": "Cemento 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0043_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0043_320x.jpg?v=1783086878"
      },
      {
        "title": "Cemento 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0044_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0044_320x.jpg?v=1783086878"
      },
      {
        "title": "Cemento 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0045_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0045_320x.jpg?v=1783086878"
      },
      {
        "title": "Cemento 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0046_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0046_320x.jpg?v=1783086878"
      },
      {
        "title": "Cemento 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0047_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0047_320x.jpg?v=1783086878"
      },
      {
        "title": "Cemento 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0048_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0048_320x.jpg?v=1783086878"
      },
      {
        "title": "Cemento 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0049_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0049_320x.jpg?v=1783086878"
      },
      {
        "title": "Cemento 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0050_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0050_320x.jpg?v=1783086879"
      },
      {
        "title": "Cemento 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0051_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0051_320x.jpg?v=1783086881"
      },
      {
        "title": "Cemento 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0052_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0052_320x.jpg?v=1783086879"
      },
      {
        "title": "Cemento 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0053_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0053_320x.jpg?v=1783086879"
      },
      {
        "title": "Cemento 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0054_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0054_320x.jpg?v=1783086880"
      },
      {
        "title": "Cemento 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0055_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0055_320x.jpg?v=1783086880"
      },
      {
        "title": "Cemento 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0056_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0056_320x.jpg?v=1783086879"
      },
      {
        "title": "Cemento 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0057_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0057_320x.jpg?v=1783086881"
      },
      {
        "title": "Cemento 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0058_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0058_320x.jpg?v=1783086881"
      },
      {
        "title": "Cemento 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0059_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0059_320x.jpg?v=1783086881"
      },
      {
        "title": "Cemento 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0060_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0060_320x.jpg?v=1783086881"
      },
      {
        "title": "Cemento 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0061_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0061_320x.jpg?v=1783086880"
      },
      {
        "title": "Cemento 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0062_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0062_320x.jpg?v=1783086880"
      },
      {
        "title": "Cemento 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0063_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0063_320x.jpg?v=1783086880"
      },
      {
        "title": "Cemento 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0064_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cemento-0064_320x.jpg?v=1783086881"
      }
    ]
  },
  {
    "title": "3D",
    "count": 65,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-3d_1600x.webp?v=1783086878",
    "items": [
      {
        "title": "3D 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0001_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0001_320x.jpg?v=1783086881"
      },
      {
        "title": "3D 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0002_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0002_320x.jpg?v=1783086881"
      },
      {
        "title": "3D 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0003_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0003_320x.jpg?v=1783086881"
      },
      {
        "title": "3D 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0004_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0004_320x.jpg?v=1783086881"
      },
      {
        "title": "3D 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0005_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0005_320x.jpg?v=1783086881"
      },
      {
        "title": "3D 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0006_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0006_320x.jpg?v=1783086881"
      },
      {
        "title": "3D 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0007_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0007_320x.jpg?v=1783086881"
      },
      {
        "title": "3D 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0008_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0008_320x.jpg?v=1783086882"
      },
      {
        "title": "3D 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0009_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0009_320x.jpg?v=1783086882"
      },
      {
        "title": "3D 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0010_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0010_320x.jpg?v=1783086882"
      },
      {
        "title": "3D 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0011_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0011_320x.jpg?v=1783086882"
      },
      {
        "title": "3D 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0012_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0012_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0013_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0013_320x.jpg?v=1783086882"
      },
      {
        "title": "3D 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0014_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0014_320x.jpg?v=1783086882"
      },
      {
        "title": "3D 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0015_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0015_320x.jpg?v=1783086882"
      },
      {
        "title": "3D 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0016_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0016_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0017_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0017_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0018_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0018_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0019_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0019_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0020_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0020_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0021_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0021_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0022_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0022_320x.jpg?v=1783086884"
      },
      {
        "title": "3D 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0023_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0023_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0024_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0024_320x.jpg?v=1783086883"
      },
      {
        "title": "3D 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0025_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0025_320x.jpg?v=1783086884"
      },
      {
        "title": "3D 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0026_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0026_320x.jpg?v=1783086884"
      },
      {
        "title": "3D 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0027_1600x.jpg?v=1783086871",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0027_320x.jpg?v=1783086871"
      },
      {
        "title": "3D 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0028_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0028_320x.jpg?v=1783086872"
      },
      {
        "title": "3D 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0029_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0029_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0030_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0030_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0031_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0031_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0032_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0032_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0033_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0033_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0034_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0034_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0035_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0035_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0036_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0036_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0037_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0037_320x.jpg?v=1783086873"
      },
      {
        "title": "3D 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0038_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0038_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0039_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0039_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0040_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0040_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0041_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0041_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0042_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0042_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0043_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0043_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0044_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0044_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0045_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0045_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0046_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0046_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0047_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0047_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0048_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0048_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0049_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0049_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0050_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0050_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0051_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0051_320x.jpg?v=1783086874"
      },
      {
        "title": "3D 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0052_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0052_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0053_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0053_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0054_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0054_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0055_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0055_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0056_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0056_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0057_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0057_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0058_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0058_320x.jpg?v=1783086875"
      },
      {
        "title": "3D 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0059_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0059_320x.jpg?v=1783086876"
      },
      {
        "title": "3D 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0060_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0060_320x.jpg?v=1783086876"
      },
      {
        "title": "3D 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0061_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0061_320x.jpg?v=1783086876"
      },
      {
        "title": "3D 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0062_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0062_320x.jpg?v=1783086876"
      },
      {
        "title": "3D 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0063_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0063_320x.jpg?v=1783086876"
      },
      {
        "title": "3D 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0064_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0064_320x.jpg?v=1783086876"
      },
      {
        "title": "3D 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0065_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-3d-0065_320x.jpg?v=1783086876"
      }
    ]
  },
  {
    "title": "Astratto",
    "count": 66,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-astratto_1600x.webp?v=1783086874",
    "items": [
      {
        "title": "Astratto 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0001_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0001_320x.jpg?v=1783086877"
      },
      {
        "title": "Astratto 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0002_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0002_320x.jpg?v=1783086877"
      },
      {
        "title": "Astratto 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0003_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0003_320x.jpg?v=1783086877"
      },
      {
        "title": "Astratto 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0004_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0004_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0005_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0005_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0006_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0006_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0007_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0007_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0008_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0008_320x.jpg?v=1783086877"
      },
      {
        "title": "Astratto 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0009_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0009_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0010_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0010_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0011_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0011_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0012_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0012_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0013_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0013_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0014_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0014_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0015_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0015_320x.jpg?v=1783086878"
      },
      {
        "title": "Astratto 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0016_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0016_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0017_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0017_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0018_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0018_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0019_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0019_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0020_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0020_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0021_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0021_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0022_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0022_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0023_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0023_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0024_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0024_320x.jpg?v=1783086880"
      },
      {
        "title": "Astratto 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0025_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0025_320x.jpg?v=1783086880"
      },
      {
        "title": "Astratto 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0026_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0026_320x.jpg?v=1783086880"
      },
      {
        "title": "Astratto 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0027_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0027_320x.jpg?v=1783086879"
      },
      {
        "title": "Astratto 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0028_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0028_320x.jpg?v=1783086880"
      },
      {
        "title": "Astratto 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0029_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0029_320x.jpg?v=1783086880"
      },
      {
        "title": "Astratto 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0030_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0030_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0031_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0031_320x.jpg?v=1783086880"
      },
      {
        "title": "Astratto 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0032_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0032_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0033_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0033_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0034_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0034_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0035_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0035_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0036_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0036_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0037_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0037_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0038_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0038_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0039_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0039_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0040_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0040_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0041_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0041_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0042_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0042_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0043_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0043_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0044_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0044_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0045_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0045_320x.jpg?v=1783086881"
      },
      {
        "title": "Astratto 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0046_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0046_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0047_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0047_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0048_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0048_320x.jpg?v=1783086883"
      },
      {
        "title": "Astratto 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0049_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0049_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0050_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0050_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0051_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0051_320x.jpg?v=1783086882"
      },
      {
        "title": "Astratto 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0052_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0052_320x.jpg?v=1783086883"
      },
      {
        "title": "Astratto 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0053_1600x.jpg?v=1783086871",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0053_320x.jpg?v=1783086871"
      },
      {
        "title": "Astratto 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0054_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0054_320x.jpg?v=1783086873"
      },
      {
        "title": "Astratto 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0055_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0055_320x.jpg?v=1783086873"
      },
      {
        "title": "Astratto 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0056_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0056_320x.jpg?v=1783086873"
      },
      {
        "title": "Astratto 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0057_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0057_320x.jpg?v=1783086872"
      },
      {
        "title": "Astratto 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0058_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0058_320x.jpg?v=1783086873"
      },
      {
        "title": "Astratto 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0059_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0059_320x.jpg?v=1783086874"
      },
      {
        "title": "Astratto 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0060_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0060_320x.jpg?v=1783086873"
      },
      {
        "title": "Astratto 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0061_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0061_320x.jpg?v=1783086873"
      },
      {
        "title": "Astratto 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0062_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0062_320x.jpg?v=1783086874"
      },
      {
        "title": "Astratto 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0063_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0063_320x.jpg?v=1783086874"
      },
      {
        "title": "Astratto 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0064_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0064_320x.jpg?v=1783086874"
      },
      {
        "title": "Astratto 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0065_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0065_320x.jpg?v=1783086874"
      },
      {
        "title": "Astratto 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0066_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-astratto-0066_320x.jpg?v=1783086874"
      }
    ]
  },
  {
    "title": "Geometrico",
    "count": 74,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-geometrico_1600x.webp?v=1783086872",
    "items": [
      {
        "title": "Geometrico 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0001_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0001_320x.jpg?v=1783086875"
      },
      {
        "title": "Geometrico 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0002_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0002_320x.jpg?v=1783086875"
      },
      {
        "title": "Geometrico 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0003_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0003_320x.jpg?v=1783086875"
      },
      {
        "title": "Geometrico 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0004_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0004_320x.jpg?v=1783086876"
      },
      {
        "title": "Geometrico 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0005_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0005_320x.jpg?v=1783086875"
      },
      {
        "title": "Geometrico 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0006_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0006_320x.jpg?v=1783086876"
      },
      {
        "title": "Geometrico 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0007_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0007_320x.jpg?v=1783086876"
      },
      {
        "title": "Geometrico 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0008_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0008_320x.jpg?v=1783086876"
      },
      {
        "title": "Geometrico 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0009_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0009_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0010_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0010_320x.jpg?v=1783086876"
      },
      {
        "title": "Geometrico 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0011_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0011_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0012_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0012_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0013_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0013_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0014_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0014_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0015_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0015_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0016_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0016_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0017_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0017_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0018_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0018_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0019_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0019_320x.jpg?v=1783086877"
      },
      {
        "title": "Geometrico 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0020_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0020_320x.jpg?v=1783086878"
      },
      {
        "title": "Geometrico 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0021_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0021_320x.jpg?v=1783086878"
      },
      {
        "title": "Geometrico 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0022_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0022_320x.jpg?v=1783086878"
      },
      {
        "title": "Geometrico 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0023_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0023_320x.jpg?v=1783086878"
      },
      {
        "title": "Geometrico 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0024_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0024_320x.jpg?v=1783086878"
      },
      {
        "title": "Geometrico 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0025_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0025_320x.jpg?v=1783086879"
      },
      {
        "title": "Geometrico 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0026_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0026_320x.jpg?v=1783086879"
      },
      {
        "title": "Geometrico 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0027_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0027_320x.jpg?v=1783086879"
      },
      {
        "title": "Geometrico 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0028_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0028_320x.jpg?v=1783086880"
      },
      {
        "title": "Geometrico 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0029_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0029_320x.jpg?v=1783086879"
      },
      {
        "title": "Geometrico 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0030_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0030_320x.jpg?v=1783086879"
      },
      {
        "title": "Geometrico 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0031_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0031_320x.jpg?v=1783086880"
      },
      {
        "title": "Geometrico 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0032_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0032_320x.jpg?v=1783086879"
      },
      {
        "title": "Geometrico 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0033_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0033_320x.jpg?v=1783086880"
      },
      {
        "title": "Geometrico 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0034_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0034_320x.jpg?v=1783086880"
      },
      {
        "title": "Geometrico 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0035_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0035_320x.jpg?v=1783086881"
      },
      {
        "title": "Geometrico 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0036_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0036_320x.jpg?v=1783086881"
      },
      {
        "title": "Geometrico 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0037_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0037_320x.jpg?v=1783086881"
      },
      {
        "title": "Geometrico 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0038_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0038_320x.jpg?v=1783086881"
      },
      {
        "title": "Geometrico 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0039_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0039_320x.jpg?v=1783086881"
      },
      {
        "title": "Geometrico 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0040_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0040_320x.jpg?v=1783086882"
      },
      {
        "title": "Geometrico 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0041_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0041_320x.jpg?v=1783086881"
      },
      {
        "title": "Geometrico 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0042_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0042_320x.jpg?v=1783086882"
      },
      {
        "title": "Geometrico 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0043_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0043_320x.jpg?v=1783086882"
      },
      {
        "title": "Geometrico 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0044_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0044_320x.jpg?v=1783086882"
      },
      {
        "title": "Geometrico 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0045_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0045_320x.jpg?v=1783086883"
      },
      {
        "title": "Geometrico 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0046_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0046_320x.jpg?v=1783086883"
      },
      {
        "title": "Geometrico 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0047_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0047_320x.jpg?v=1783086883"
      },
      {
        "title": "Geometrico 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0048_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0048_320x.jpg?v=1783086883"
      },
      {
        "title": "Geometrico 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0049_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0049_320x.jpg?v=1783086883"
      },
      {
        "title": "Geometrico 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0050_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0050_320x.jpg?v=1783086883"
      },
      {
        "title": "Geometrico 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0051_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0051_320x.jpg?v=1783086883"
      },
      {
        "title": "Geometrico 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0052_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0052_320x.jpg?v=1783086884"
      },
      {
        "title": "Geometrico 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0053_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0053_320x.jpg?v=1783086884"
      },
      {
        "title": "Geometrico 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0054_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0054_320x.jpg?v=1783086884"
      },
      {
        "title": "Geometrico 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0055_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0055_320x.jpg?v=1783086884"
      },
      {
        "title": "Geometrico 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0056_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0056_320x.jpg?v=1783086884"
      },
      {
        "title": "Geometrico 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0057_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0057_320x.jpg?v=1783086885"
      },
      {
        "title": "Geometrico 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0058_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0058_320x.jpg?v=1783086885"
      },
      {
        "title": "Geometrico 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0059_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0059_320x.jpg?v=1783086885"
      },
      {
        "title": "Geometrico 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0060_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0060_320x.jpg?v=1783086885"
      },
      {
        "title": "Geometrico 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0061_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0061_320x.jpg?v=1783086885"
      },
      {
        "title": "Geometrico 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0062_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0062_320x.jpg?v=1783086886"
      },
      {
        "title": "Geometrico 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0063_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0063_320x.jpg?v=1783086885"
      },
      {
        "title": "Geometrico 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0064_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0064_320x.jpg?v=1783086886"
      },
      {
        "title": "Geometrico 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0065_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0065_320x.jpg?v=1783086887"
      },
      {
        "title": "Geometrico 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0066_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0066_320x.jpg?v=1783086886"
      },
      {
        "title": "Geometrico 0067",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0067_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0067_320x.jpg?v=1783086886"
      },
      {
        "title": "Geometrico 0068",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0068_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0068_320x.jpg?v=1783086886"
      },
      {
        "title": "Geometrico 0069",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0069_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0069_320x.jpg?v=1783086886"
      },
      {
        "title": "Geometrico 0070",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0070_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0070_320x.jpg?v=1783086886"
      },
      {
        "title": "Geometrico 0071",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0071_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0071_320x.jpg?v=1783086887"
      },
      {
        "title": "Geometrico 0072",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0072_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0072_320x.jpg?v=1783086887"
      },
      {
        "title": "Geometrico 0073",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0073_1600x.jpg?v=1783086888",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0073_320x.jpg?v=1783086888"
      },
      {
        "title": "Geometrico 0074",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0074_1600x.jpg?v=1783086888",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-geometrico-0074_320x.jpg?v=1783086888"
      }
    ]
  },
  {
    "title": "Arabesco",
    "count": 35,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-arabesco_1600x.webp?v=1783086885",
    "items": [
      {
        "title": "Arabesco 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0001_1600x.jpg?v=1783086888",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0001_320x.jpg?v=1783086888"
      },
      {
        "title": "Arabesco 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0002_1600x.jpg?v=1783086888",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0002_320x.jpg?v=1783086888"
      },
      {
        "title": "Arabesco 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0003_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0003_320x.jpg?v=1783086872"
      },
      {
        "title": "Arabesco 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0004_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0004_320x.jpg?v=1783086873"
      },
      {
        "title": "Arabesco 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0005_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0005_320x.jpg?v=1783086873"
      },
      {
        "title": "Arabesco 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0006_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0006_320x.jpg?v=1783086873"
      },
      {
        "title": "Arabesco 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0007_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0007_320x.jpg?v=1783086873"
      },
      {
        "title": "Arabesco 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0008_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0008_320x.jpg?v=1783086874"
      },
      {
        "title": "Arabesco 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0009_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0009_320x.jpg?v=1783086873"
      },
      {
        "title": "Arabesco 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0010_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0010_320x.jpg?v=1783086873"
      },
      {
        "title": "Arabesco 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0011_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0011_320x.jpg?v=1783086874"
      },
      {
        "title": "Arabesco 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0012_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0012_320x.jpg?v=1783086874"
      },
      {
        "title": "Arabesco 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0013_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0013_320x.jpg?v=1783086874"
      },
      {
        "title": "Arabesco 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0014_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0014_320x.jpg?v=1783086874"
      },
      {
        "title": "Arabesco 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0015_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0015_320x.jpg?v=1783086874"
      },
      {
        "title": "Arabesco 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0016_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0016_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0017_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0017_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0018_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0018_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0019_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0019_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0020_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0020_320x.jpg?v=1783086874"
      },
      {
        "title": "Arabesco 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0021_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0021_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0022_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0022_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0023_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0023_320x.jpg?v=1783086876"
      },
      {
        "title": "Arabesco 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0024_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0024_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0025_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0025_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0026_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0026_320x.jpg?v=1783086875"
      },
      {
        "title": "Arabesco 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0027_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0027_320x.jpg?v=1783086876"
      },
      {
        "title": "Arabesco 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0028_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0028_320x.jpg?v=1783086876"
      },
      {
        "title": "Arabesco 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0029_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0029_320x.jpg?v=1783086876"
      },
      {
        "title": "Arabesco 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0030_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0030_320x.jpg?v=1783086876"
      },
      {
        "title": "Arabesco 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0031_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0031_320x.jpg?v=1783086877"
      },
      {
        "title": "Arabesco 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0032_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0032_320x.jpg?v=1783086877"
      },
      {
        "title": "Arabesco 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0033_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0033_320x.jpg?v=1783086877"
      },
      {
        "title": "Arabesco 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0034_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0034_320x.jpg?v=1783086877"
      },
      {
        "title": "Arabesco 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0035_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-arabesco-0035_320x.jpg?v=1783086877"
      }
    ]
  },
  {
    "title": "Tessuti",
    "count": 42,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-tessuti_1600x.webp?v=1783086873",
    "items": [
      {
        "title": "Tessuti 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0001_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0001_320x.jpg?v=1783086877"
      },
      {
        "title": "Tessuti 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0002_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0002_320x.jpg?v=1783086876"
      },
      {
        "title": "Tessuti 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0003_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0003_320x.jpg?v=1783086877"
      },
      {
        "title": "Tessuti 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0004_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0004_320x.jpg?v=1783086877"
      },
      {
        "title": "Tessuti 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0005_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0005_320x.jpg?v=1783086877"
      },
      {
        "title": "Tessuti 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0006_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0006_320x.jpg?v=1783086877"
      },
      {
        "title": "Tessuti 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0007_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0007_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0008_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0008_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0009_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0009_320x.jpg?v=1783086877"
      },
      {
        "title": "Tessuti 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0010_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0010_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0011_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0011_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0012_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0012_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0013_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0013_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0014_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0014_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0015_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0015_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0016_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0016_320x.jpg?v=1783086878"
      },
      {
        "title": "Tessuti 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0017_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0017_320x.jpg?v=1783086879"
      },
      {
        "title": "Tessuti 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0018_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0018_320x.jpg?v=1783086879"
      },
      {
        "title": "Tessuti 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0019_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0019_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0020_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0020_320x.jpg?v=1783086879"
      },
      {
        "title": "Tessuti 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0021_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0021_320x.jpg?v=1783086879"
      },
      {
        "title": "Tessuti 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0022_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0022_320x.jpg?v=1783086879"
      },
      {
        "title": "Tessuti 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0023_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0023_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0024_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0024_320x.jpg?v=1783086879"
      },
      {
        "title": "Tessuti 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0025_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0025_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0026_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0026_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0027_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0027_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0028_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0028_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0029_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0029_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0030_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0030_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0031_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0031_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0032_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0032_320x.jpg?v=1783086880"
      },
      {
        "title": "Tessuti 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0033_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0033_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0034_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0034_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0035_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0035_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0036_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0036_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0037_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0037_320x.jpg?v=1783086882"
      },
      {
        "title": "Tessuti 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0038_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0038_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0039_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0039_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0040_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0040_320x.jpg?v=1783086882"
      },
      {
        "title": "Tessuti 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0041_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0041_320x.jpg?v=1783086881"
      },
      {
        "title": "Tessuti 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0042_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-tessuti-0042_320x.jpg?v=1783086882"
      }
    ]
  },
  {
    "title": "Mattone",
    "count": 75,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-mattone_1600x.webp?v=1783086879",
    "items": [
      {
        "title": "Mattone 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0001_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0001_320x.jpg?v=1783086882"
      },
      {
        "title": "Mattone 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0002_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0002_320x.jpg?v=1783086882"
      },
      {
        "title": "Mattone 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0003_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0003_320x.jpg?v=1783086882"
      },
      {
        "title": "Mattone 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0004_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0004_320x.jpg?v=1783086882"
      },
      {
        "title": "Mattone 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0005_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0005_320x.jpg?v=1783086882"
      },
      {
        "title": "Mattone 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0006_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0006_320x.jpg?v=1783086882"
      },
      {
        "title": "Mattone 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0007_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0007_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0008_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0008_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0009_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0009_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0010_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0010_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0011_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0011_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0012_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0012_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0013_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0013_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0014_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0014_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0015_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0015_320x.jpg?v=1783086883"
      },
      {
        "title": "Mattone 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0016_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0016_320x.jpg?v=1783086872"
      },
      {
        "title": "Mattone 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0017_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0017_320x.jpg?v=1783086873"
      },
      {
        "title": "Mattone 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0018_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0018_320x.jpg?v=1783086873"
      },
      {
        "title": "Mattone 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0019_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0019_320x.jpg?v=1783086873"
      },
      {
        "title": "Mattone 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0020_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0020_320x.jpg?v=1783086873"
      },
      {
        "title": "Mattone 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0021_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0021_320x.jpg?v=1783086873"
      },
      {
        "title": "Mattone 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0022_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0022_320x.jpg?v=1783086873"
      },
      {
        "title": "Mattone 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0023_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0023_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0024_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0024_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0025_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0025_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0026_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0026_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0027_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0027_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0028_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0028_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0029_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0029_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0030_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0030_320x.jpg?v=1783086875"
      },
      {
        "title": "Mattone 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0031_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0031_320x.jpg?v=1783086874"
      },
      {
        "title": "Mattone 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0032_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0032_320x.jpg?v=1783086875"
      },
      {
        "title": "Mattone 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0033_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0033_320x.jpg?v=1783086875"
      },
      {
        "title": "Mattone 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0034_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0034_320x.jpg?v=1783086875"
      },
      {
        "title": "Mattone 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0035_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0035_320x.jpg?v=1783086875"
      },
      {
        "title": "Mattone 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0036_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0036_320x.jpg?v=1783086875"
      },
      {
        "title": "Mattone 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0037_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0037_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0038_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0038_320x.jpg?v=1783086875"
      },
      {
        "title": "Mattone 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0039_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0039_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0040_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0040_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0041_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0041_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0042_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0042_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0043_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0043_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0044_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0044_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0045_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0045_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0046_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0046_320x.jpg?v=1783086876"
      },
      {
        "title": "Mattone 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0047_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0047_320x.jpg?v=1783086877"
      },
      {
        "title": "Mattone 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0048_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0048_320x.jpg?v=1783086877"
      },
      {
        "title": "Mattone 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0049_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0049_320x.jpg?v=1783086877"
      },
      {
        "title": "Mattone 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0050_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0050_320x.jpg?v=1783086877"
      },
      {
        "title": "Mattone 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0051_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0051_320x.jpg?v=1783086877"
      },
      {
        "title": "Mattone 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0052_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0052_320x.jpg?v=1783086877"
      },
      {
        "title": "Mattone 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0053_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0053_320x.jpg?v=1783086877"
      },
      {
        "title": "Mattone 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0054_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0054_320x.jpg?v=1783086878"
      },
      {
        "title": "Mattone 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0055_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0055_320x.jpg?v=1783086878"
      },
      {
        "title": "Mattone 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0056_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0056_320x.jpg?v=1783086878"
      },
      {
        "title": "Mattone 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0057_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0057_320x.jpg?v=1783086878"
      },
      {
        "title": "Mattone 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0058_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0058_320x.jpg?v=1783086878"
      },
      {
        "title": "Mattone 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0059_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0059_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0060_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0060_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0061_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0061_320x.jpg?v=1783086878"
      },
      {
        "title": "Mattone 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0062_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0062_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0063_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0063_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0064_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0064_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0065_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0065_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0066_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0066_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0067",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0067_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0067_320x.jpg?v=1783086879"
      },
      {
        "title": "Mattone 0068",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0068_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0068_320x.jpg?v=1783086880"
      },
      {
        "title": "Mattone 0069",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0069_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0069_320x.jpg?v=1783086880"
      },
      {
        "title": "Mattone 0070",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0070_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0070_320x.jpg?v=1783086880"
      },
      {
        "title": "Mattone 0071",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0071_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0071_320x.jpg?v=1783086880"
      },
      {
        "title": "Mattone 0072",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0072_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0072_320x.jpg?v=1783086880"
      },
      {
        "title": "Mattone 0073",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0073_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0073_320x.jpg?v=1783086881"
      },
      {
        "title": "Mattone 0074",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0074_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0074_320x.jpg?v=1783086881"
      },
      {
        "title": "Mattone 0075",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0075_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-mattone-0075_320x.jpg?v=1783086881"
      }
    ]
  },
  {
    "title": "Pietra",
    "count": 75,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-pietra_1600x.webp?v=1783086878",
    "items": [
      {
        "title": "Pietra 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0001_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0001_320x.jpg?v=1783086881"
      },
      {
        "title": "Pietra 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0002_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0002_320x.jpg?v=1783086882"
      },
      {
        "title": "Pietra 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0003_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0003_320x.jpg?v=1783086882"
      },
      {
        "title": "Pietra 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0004_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0004_320x.jpg?v=1783086882"
      },
      {
        "title": "Pietra 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0005_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0005_320x.jpg?v=1783086882"
      },
      {
        "title": "Pietra 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0006_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0006_320x.jpg?v=1783086882"
      },
      {
        "title": "Pietra 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0007_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0007_320x.jpg?v=1783086882"
      },
      {
        "title": "Pietra 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0008_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0008_320x.jpg?v=1783086882"
      },
      {
        "title": "Pietra 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0009_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0009_320x.jpg?v=1783086883"
      },
      {
        "title": "Pietra 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0010_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0010_320x.jpg?v=1783086883"
      },
      {
        "title": "Pietra 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0011_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0011_320x.jpg?v=1783086883"
      },
      {
        "title": "Pietra 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0012_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0012_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0013_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0013_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0014_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0014_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0015_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0015_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0016_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0016_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0017_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0017_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0018_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0018_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0019_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0019_320x.jpg?v=1783086884"
      },
      {
        "title": "Pietra 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0020_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0020_320x.jpg?v=1783086885"
      },
      {
        "title": "Pietra 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0021_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0021_320x.jpg?v=1783086885"
      },
      {
        "title": "Pietra 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0022_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0022_320x.jpg?v=1783086885"
      },
      {
        "title": "Pietra 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0023_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0023_320x.jpg?v=1783086885"
      },
      {
        "title": "Pietra 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0024_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0024_320x.jpg?v=1783086885"
      },
      {
        "title": "Pietra 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0025_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0025_320x.jpg?v=1783086886"
      },
      {
        "title": "Pietra 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0026_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0026_320x.jpg?v=1783086886"
      },
      {
        "title": "Pietra 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0027_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0027_320x.jpg?v=1783086886"
      },
      {
        "title": "Pietra 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0028_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0028_320x.jpg?v=1783086886"
      },
      {
        "title": "Pietra 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0029_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0029_320x.jpg?v=1783086886"
      },
      {
        "title": "Pietra 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0030_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0030_320x.jpg?v=1783086886"
      },
      {
        "title": "Pietra 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0031_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0031_320x.jpg?v=1783086887"
      },
      {
        "title": "Pietra 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0032_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0032_320x.jpg?v=1783086872"
      },
      {
        "title": "Pietra 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0033_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0033_320x.jpg?v=1783086873"
      },
      {
        "title": "Pietra 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0034_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0034_320x.jpg?v=1783086873"
      },
      {
        "title": "Pietra 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0035_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0035_320x.jpg?v=1783086873"
      },
      {
        "title": "Pietra 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0036_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0036_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0037_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0037_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0038_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0038_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0039_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0039_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0040_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0040_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0041_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0041_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0042_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0042_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0043_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0043_320x.jpg?v=1783086874"
      },
      {
        "title": "Pietra 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0044_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0044_320x.jpg?v=1783086876"
      },
      {
        "title": "Pietra 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0045_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0045_320x.jpg?v=1783086875"
      },
      {
        "title": "Pietra 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0046_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0046_320x.jpg?v=1783086875"
      },
      {
        "title": "Pietra 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0047_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0047_320x.jpg?v=1783086875"
      },
      {
        "title": "Pietra 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0048_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0048_320x.jpg?v=1783086875"
      },
      {
        "title": "Pietra 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0049_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0049_320x.jpg?v=1783086875"
      },
      {
        "title": "Pietra 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0050_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0050_320x.jpg?v=1783086875"
      },
      {
        "title": "Pietra 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0051_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0051_320x.jpg?v=1783086875"
      },
      {
        "title": "Pietra 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0052_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0052_320x.jpg?v=1783086876"
      },
      {
        "title": "Pietra 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0053_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0053_320x.jpg?v=1783086876"
      },
      {
        "title": "Pietra 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0054_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0054_320x.jpg?v=1783086876"
      },
      {
        "title": "Pietra 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0055_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0055_320x.jpg?v=1783086876"
      },
      {
        "title": "Pietra 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0056_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0056_320x.jpg?v=1783086876"
      },
      {
        "title": "Pietra 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0057_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0057_320x.jpg?v=1783086876"
      },
      {
        "title": "Pietra 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0058_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0058_320x.jpg?v=1783086877"
      },
      {
        "title": "Pietra 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0059_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0059_320x.jpg?v=1783086877"
      },
      {
        "title": "Pietra 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0060_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0060_320x.jpg?v=1783086877"
      },
      {
        "title": "Pietra 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0061_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0061_320x.jpg?v=1783086877"
      },
      {
        "title": "Pietra 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0062_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0062_320x.jpg?v=1783086877"
      },
      {
        "title": "Pietra 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0063_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0063_320x.jpg?v=1783086877"
      },
      {
        "title": "Pietra 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0064_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0064_320x.jpg?v=1783086878"
      },
      {
        "title": "Pietra 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0065_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0065_320x.jpg?v=1783086877"
      },
      {
        "title": "Pietra 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0066_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0066_320x.jpg?v=1783086878"
      },
      {
        "title": "Pietra 0067",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0067_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0067_320x.jpg?v=1783086878"
      },
      {
        "title": "Pietra 0068",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0068_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0068_320x.jpg?v=1783086879"
      },
      {
        "title": "Pietra 0069",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0069_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0069_320x.jpg?v=1783086878"
      },
      {
        "title": "Pietra 0070",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0070_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0070_320x.jpg?v=1783086878"
      },
      {
        "title": "Pietra 0071",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0071_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0071_320x.jpg?v=1783086878"
      },
      {
        "title": "Pietra 0072",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0072_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0072_320x.jpg?v=1783086878"
      },
      {
        "title": "Pietra 0073",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0073_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0073_320x.jpg?v=1783086879"
      },
      {
        "title": "Pietra 0074",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0074_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0074_320x.jpg?v=1783086879"
      },
      {
        "title": "Pietra 0075",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0075_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-pietra-0075_320x.jpg?v=1783086879"
      }
    ]
  },
  {
    "title": "Piastrelle",
    "count": 65,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-piastrelle_1600x.webp?v=1783086875",
    "items": [
      {
        "title": "Piastrelle 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0001_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0001_320x.jpg?v=1783086878"
      },
      {
        "title": "Piastrelle 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0002_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0002_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0003_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0003_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0004_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0004_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0005_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0005_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0006_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0006_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0007_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0007_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0008_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0008_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0009_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0009_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0010_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0010_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0011_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0011_320x.jpg?v=1783086879"
      },
      {
        "title": "Piastrelle 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0012_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0012_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0013_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0013_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0014_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0014_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0015_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0015_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0016_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0016_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0017_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0017_320x.jpg?v=1783086880"
      },
      {
        "title": "Piastrelle 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0018_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0018_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0019_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0019_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0020_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0020_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0021_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0021_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0022_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0022_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0023_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0023_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0024_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0024_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0025_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0025_320x.jpg?v=1783086881"
      },
      {
        "title": "Piastrelle 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0026_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0026_320x.jpg?v=1783086882"
      },
      {
        "title": "Piastrelle 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0027_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0027_320x.jpg?v=1783086882"
      },
      {
        "title": "Piastrelle 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0028_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0028_320x.jpg?v=1783086882"
      },
      {
        "title": "Piastrelle 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0029_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0029_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0030_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0030_320x.jpg?v=1783086882"
      },
      {
        "title": "Piastrelle 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0031_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0031_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0032_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0032_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0033_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0033_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0034_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0034_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0035_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0035_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0036_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0036_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0037_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0037_320x.jpg?v=1783086884"
      },
      {
        "title": "Piastrelle 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0038_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0038_320x.jpg?v=1783086883"
      },
      {
        "title": "Piastrelle 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0039_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0039_320x.jpg?v=1783086884"
      },
      {
        "title": "Piastrelle 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0040_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0040_320x.jpg?v=1783086884"
      },
      {
        "title": "Piastrelle 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0041_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0041_320x.jpg?v=1783086884"
      },
      {
        "title": "Piastrelle 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0042_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0042_320x.jpg?v=1783086884"
      },
      {
        "title": "Piastrelle 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0043_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0043_320x.jpg?v=1783086884"
      },
      {
        "title": "Piastrelle 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0044_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0044_320x.jpg?v=1783086885"
      },
      {
        "title": "Piastrelle 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0045_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0045_320x.jpg?v=1783086884"
      },
      {
        "title": "Piastrelle 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0046_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0046_320x.jpg?v=1783086885"
      },
      {
        "title": "Piastrelle 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0047_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0047_320x.jpg?v=1783086885"
      },
      {
        "title": "Piastrelle 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0048_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0048_320x.jpg?v=1783086872"
      },
      {
        "title": "Piastrelle 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0049_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0049_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0050_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0050_320x.jpg?v=1783086872"
      },
      {
        "title": "Piastrelle 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0051_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0051_320x.jpg?v=1783086872"
      },
      {
        "title": "Piastrelle 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0052_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0052_320x.jpg?v=1783086872"
      },
      {
        "title": "Piastrelle 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0053_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0053_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0054_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0054_320x.jpg?v=1783086872"
      },
      {
        "title": "Piastrelle 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0055_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0055_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0056_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0056_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0057_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0057_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0058_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0058_320x.jpg?v=1783086874"
      },
      {
        "title": "Piastrelle 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0059_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0059_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0060_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0060_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0061_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0061_320x.jpg?v=1783086873"
      },
      {
        "title": "Piastrelle 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0062_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0062_320x.jpg?v=1783086874"
      },
      {
        "title": "Piastrelle 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0063_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0063_320x.jpg?v=1783086874"
      },
      {
        "title": "Piastrelle 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0064_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0064_320x.jpg?v=1783086874"
      },
      {
        "title": "Piastrelle 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0065_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-piastrelle-0065_320x.jpg?v=1783086874"
      }
    ]
  },
  {
    "title": "Legno",
    "count": 70,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-legno_1600x.webp?v=1783086871",
    "items": [
      {
        "title": "Legno 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0001_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0001_320x.jpg?v=1783086874"
      },
      {
        "title": "Legno 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0002_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0002_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0003_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0003_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0004_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0004_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0005_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0005_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0006_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0006_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0007_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0007_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0008_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0008_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0009_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0009_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0010_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0010_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0011_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0011_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0012_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0012_320x.jpg?v=1783086875"
      },
      {
        "title": "Legno 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0013_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0013_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0014_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0014_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0015_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0015_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0016_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0016_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0017_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0017_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0018_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0018_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0019_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0019_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0020_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0020_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0021_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0021_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0022_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0022_320x.jpg?v=1783086876"
      },
      {
        "title": "Legno 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0023_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0023_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0024_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0024_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0025_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0025_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0026_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0026_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0027_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0027_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0028_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0028_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0029_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0029_320x.jpg?v=1783086877"
      },
      {
        "title": "Legno 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0030_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0030_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0031_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0031_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0032_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0032_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0033_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0033_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0034_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0034_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0035_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0035_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0036_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0036_320x.jpg?v=1783086878"
      },
      {
        "title": "Legno 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0037_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0037_320x.jpg?v=1783086879"
      },
      {
        "title": "Legno 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0038_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0038_320x.jpg?v=1783086879"
      },
      {
        "title": "Legno 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0039_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0039_320x.jpg?v=1783086879"
      },
      {
        "title": "Legno 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0040_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0040_320x.jpg?v=1783086879"
      },
      {
        "title": "Legno 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0041_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0041_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0042_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0042_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0043_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0043_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0044_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0044_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0045_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0045_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0046_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0046_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0047_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0047_320x.jpg?v=1783086879"
      },
      {
        "title": "Legno 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0048_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0048_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0049_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0049_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0050_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0050_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0051_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0051_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0052_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0052_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0053_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0053_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0054_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0054_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0055_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0055_320x.jpg?v=1783086880"
      },
      {
        "title": "Legno 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0056_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0056_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0057_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0057_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0058_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0058_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0059_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0059_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0060_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0060_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0061_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0061_320x.jpg?v=1783086882"
      },
      {
        "title": "Legno 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0062_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0062_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0063_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0063_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0064_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0064_320x.jpg?v=1783086881"
      },
      {
        "title": "Legno 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0065_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0065_320x.jpg?v=1783086882"
      },
      {
        "title": "Legno 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0066_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0066_320x.jpg?v=1783086882"
      },
      {
        "title": "Legno 0067",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0067_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0067_320x.jpg?v=1783086882"
      },
      {
        "title": "Legno 0068",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0068_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0068_320x.jpg?v=1783086882"
      },
      {
        "title": "Legno 0069",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0069_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0069_320x.jpg?v=1783086882"
      },
      {
        "title": "Legno 0070",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0070_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-legno-0070_320x.jpg?v=1783086882"
      }
    ]
  },
  {
    "title": "Metallo",
    "count": 37,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-metallo_1600x.webp?v=1783086880",
    "items": [
      {
        "title": "Metallo 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0001_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0001_320x.jpg?v=1783086883"
      },
      {
        "title": "Metallo 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0002_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0002_320x.jpg?v=1783086883"
      },
      {
        "title": "Metallo 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0003_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0003_320x.jpg?v=1783086872"
      },
      {
        "title": "Metallo 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0004_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0004_320x.jpg?v=1783086872"
      },
      {
        "title": "Metallo 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0005_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0005_320x.jpg?v=1783086872"
      },
      {
        "title": "Metallo 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0006_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0006_320x.jpg?v=1783086873"
      },
      {
        "title": "Metallo 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0007_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0007_320x.jpg?v=1783086873"
      },
      {
        "title": "Metallo 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0008_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0008_320x.jpg?v=1783086873"
      },
      {
        "title": "Metallo 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0009_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0009_320x.jpg?v=1783086873"
      },
      {
        "title": "Metallo 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0010_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0010_320x.jpg?v=1783086873"
      },
      {
        "title": "Metallo 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0011_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0011_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0012_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0012_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0013_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0013_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0014_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0014_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0015_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0015_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0016_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0016_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0017_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0017_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0018_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0018_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0019_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0019_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0020_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0020_320x.jpg?v=1783086874"
      },
      {
        "title": "Metallo 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0021_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0021_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0022_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0022_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0023_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0023_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0024_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0024_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0025_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0025_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0026_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0026_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0027_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0027_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0028_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0028_320x.jpg?v=1783086875"
      },
      {
        "title": "Metallo 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0029_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0029_320x.jpg?v=1783086876"
      },
      {
        "title": "Metallo 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0030_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0030_320x.jpg?v=1783086876"
      },
      {
        "title": "Metallo 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0031_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0031_320x.jpg?v=1783086876"
      },
      {
        "title": "Metallo 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0032_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0032_320x.jpg?v=1783086876"
      },
      {
        "title": "Metallo 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0033_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0033_320x.jpg?v=1783086876"
      },
      {
        "title": "Metallo 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0034_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0034_320x.jpg?v=1783086877"
      },
      {
        "title": "Metallo 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0035_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0035_320x.jpg?v=1783086877"
      },
      {
        "title": "Metallo 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0036_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0036_320x.jpg?v=1783086877"
      },
      {
        "title": "Metallo 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0037_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-metallo-0037_320x.jpg?v=1783086877"
      }
    ]
  },
  {
    "title": "Oro",
    "count": 11,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-oro_1600x.webp?v=1783086874",
    "items": [
      {
        "title": "Oro 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0001_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0001_320x.jpg?v=1783086877"
      },
      {
        "title": "Oro 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0002_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0002_320x.jpg?v=1783086877"
      },
      {
        "title": "Oro 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0003_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0003_320x.jpg?v=1783086878"
      },
      {
        "title": "Oro 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0004_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0004_320x.jpg?v=1783086878"
      },
      {
        "title": "Oro 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0005_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0005_320x.jpg?v=1783086878"
      },
      {
        "title": "Oro 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0006_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0006_320x.jpg?v=1783086878"
      },
      {
        "title": "Oro 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0007_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0007_320x.jpg?v=1783086878"
      },
      {
        "title": "Oro 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0008_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0008_320x.jpg?v=1783086878"
      },
      {
        "title": "Oro 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0009_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0009_320x.jpg?v=1783086879"
      },
      {
        "title": "Oro 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0010_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0010_320x.jpg?v=1783086879"
      },
      {
        "title": "Oro 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0011_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-oro-0011_320x.jpg?v=1783086880"
      }
    ]
  },
  {
    "title": "Urbano",
    "count": 31,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-urbano_1600x.webp?v=1783086876",
    "items": [
      {
        "title": "Urbano 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0001_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0001_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0002_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0002_320x.jpg?v=1783086879"
      },
      {
        "title": "Urbano 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0003_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0003_320x.jpg?v=1783086879"
      },
      {
        "title": "Urbano 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0004_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0004_320x.jpg?v=1783086879"
      },
      {
        "title": "Urbano 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0005_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0005_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0006_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0006_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0007_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0007_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0008_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0008_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0009_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0009_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0010_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0010_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0011_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0011_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0012_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0012_320x.jpg?v=1783086880"
      },
      {
        "title": "Urbano 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0013_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0013_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0014_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0014_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0015_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0015_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0016_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0016_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0017_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0017_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0018_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0018_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0019_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0019_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0020_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0020_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0021_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0021_320x.jpg?v=1783086881"
      },
      {
        "title": "Urbano 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0022_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0022_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0023_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0023_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0024_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0024_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0025_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0025_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0026_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0026_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0027_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0027_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0028_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0028_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0029_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0029_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0030_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0030_320x.jpg?v=1783086882"
      },
      {
        "title": "Urbano 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0031_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-urbano-0031_320x.jpg?v=1783086883"
      }
    ]
  },
  {
    "title": "Digitale",
    "count": 24,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-digitale_1600x.webp?v=1783086880",
    "items": [
      {
        "title": "Digitale 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0001_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0001_320x.jpg?v=1783086883"
      },
      {
        "title": "Digitale 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0002_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0002_320x.jpg?v=1783086884"
      },
      {
        "title": "Digitale 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0003_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0003_320x.jpg?v=1783086884"
      },
      {
        "title": "Digitale 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0004_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0004_320x.jpg?v=1783086884"
      },
      {
        "title": "Digitale 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0005_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0005_320x.jpg?v=1783086885"
      },
      {
        "title": "Digitale 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0006_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0006_320x.jpg?v=1783086884"
      },
      {
        "title": "Digitale 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0007_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0007_320x.jpg?v=1783086885"
      },
      {
        "title": "Digitale 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0008_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0008_320x.jpg?v=1783086884"
      },
      {
        "title": "Digitale 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0009_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0009_320x.jpg?v=1783086884"
      },
      {
        "title": "Digitale 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0010_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0010_320x.jpg?v=1783086885"
      },
      {
        "title": "Digitale 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0011_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0011_320x.jpg?v=1783086885"
      },
      {
        "title": "Digitale 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0012_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0012_320x.jpg?v=1783086886"
      },
      {
        "title": "Digitale 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0013_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0013_320x.jpg?v=1783086872"
      },
      {
        "title": "Digitale 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0014_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0014_320x.jpg?v=1783086873"
      },
      {
        "title": "Digitale 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0015_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0015_320x.jpg?v=1783086873"
      },
      {
        "title": "Digitale 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0016_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0016_320x.jpg?v=1783086873"
      },
      {
        "title": "Digitale 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0017_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0017_320x.jpg?v=1783086873"
      },
      {
        "title": "Digitale 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0018_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0018_320x.jpg?v=1783086873"
      },
      {
        "title": "Digitale 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0019_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0019_320x.jpg?v=1783086874"
      },
      {
        "title": "Digitale 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0020_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0020_320x.jpg?v=1783086874"
      },
      {
        "title": "Digitale 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0021_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0021_320x.jpg?v=1783086874"
      },
      {
        "title": "Digitale 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0022_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0022_320x.jpg?v=1783086874"
      },
      {
        "title": "Digitale 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0023_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0023_320x.jpg?v=1783086874"
      },
      {
        "title": "Digitale 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0024_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-digitale-0024_320x.jpg?v=1783086874"
      }
    ]
  },
  {
    "title": "Commerciale",
    "count": 70,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-commerciale_1600x.webp?v=1783086871",
    "items": [
      {
        "title": "Commerciale 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0001_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0001_320x.jpg?v=1783086875"
      },
      {
        "title": "Commerciale 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0002_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0002_320x.jpg?v=1783086875"
      },
      {
        "title": "Commerciale 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0003_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0003_320x.jpg?v=1783086875"
      },
      {
        "title": "Commerciale 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0004_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0004_320x.jpg?v=1783086875"
      },
      {
        "title": "Commerciale 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0005_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0005_320x.jpg?v=1783086875"
      },
      {
        "title": "Commerciale 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0006_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0006_320x.jpg?v=1783086876"
      },
      {
        "title": "Commerciale 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0007_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0007_320x.jpg?v=1783086876"
      },
      {
        "title": "Commerciale 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0008_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0008_320x.jpg?v=1783086876"
      },
      {
        "title": "Commerciale 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0009_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0009_320x.jpg?v=1783086876"
      },
      {
        "title": "Commerciale 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0010_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0010_320x.jpg?v=1783086876"
      },
      {
        "title": "Commerciale 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0011_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0011_320x.jpg?v=1783086876"
      },
      {
        "title": "Commerciale 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0012_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0012_320x.jpg?v=1783086877"
      },
      {
        "title": "Commerciale 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0013_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0013_320x.jpg?v=1783086877"
      },
      {
        "title": "Commerciale 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0014_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0014_320x.jpg?v=1783086877"
      },
      {
        "title": "Commerciale 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0015_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0015_320x.jpg?v=1783086877"
      },
      {
        "title": "Commerciale 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0016_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0016_320x.jpg?v=1783086878"
      },
      {
        "title": "Commerciale 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0017_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0017_320x.jpg?v=1783086877"
      },
      {
        "title": "Commerciale 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0018_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0018_320x.jpg?v=1783086878"
      },
      {
        "title": "Commerciale 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0019_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0019_320x.jpg?v=1783086878"
      },
      {
        "title": "Commerciale 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0020_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0020_320x.jpg?v=1783086877"
      },
      {
        "title": "Commerciale 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0021_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0021_320x.jpg?v=1783086878"
      },
      {
        "title": "Commerciale 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0022_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0022_320x.jpg?v=1783086878"
      },
      {
        "title": "Commerciale 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0023_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0023_320x.jpg?v=1783086878"
      },
      {
        "title": "Commerciale 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0024_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0024_320x.jpg?v=1783086879"
      },
      {
        "title": "Commerciale 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0025_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0025_320x.jpg?v=1783086879"
      },
      {
        "title": "Commerciale 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0026_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0026_320x.jpg?v=1783086878"
      },
      {
        "title": "Commerciale 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0027_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0027_320x.jpg?v=1783086879"
      },
      {
        "title": "Commerciale 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0028_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0028_320x.jpg?v=1783086879"
      },
      {
        "title": "Commerciale 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0029_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0029_320x.jpg?v=1783086879"
      },
      {
        "title": "Commerciale 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0030_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0030_320x.jpg?v=1783086880"
      },
      {
        "title": "Commerciale 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0031_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0031_320x.jpg?v=1783086880"
      },
      {
        "title": "Commerciale 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0032_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0032_320x.jpg?v=1783086881"
      },
      {
        "title": "Commerciale 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0033_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0033_320x.jpg?v=1783086880"
      },
      {
        "title": "Commerciale 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0034_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0034_320x.jpg?v=1783086881"
      },
      {
        "title": "Commerciale 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0035_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0035_320x.jpg?v=1783086881"
      },
      {
        "title": "Commerciale 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0036_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0036_320x.jpg?v=1783086881"
      },
      {
        "title": "Commerciale 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0037_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0037_320x.jpg?v=1783086880"
      },
      {
        "title": "Commerciale 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0038_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0038_320x.jpg?v=1783086881"
      },
      {
        "title": "Commerciale 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0039_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0039_320x.jpg?v=1783086881"
      },
      {
        "title": "Commerciale 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0040_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0040_320x.jpg?v=1783086881"
      },
      {
        "title": "Commerciale 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0041_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0041_320x.jpg?v=1783086882"
      },
      {
        "title": "Commerciale 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0042_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0042_320x.jpg?v=1783086882"
      },
      {
        "title": "Commerciale 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0043_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0043_320x.jpg?v=1783086883"
      },
      {
        "title": "Commerciale 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0044_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0044_320x.jpg?v=1783086882"
      },
      {
        "title": "Commerciale 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0045_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0045_320x.jpg?v=1783086882"
      },
      {
        "title": "Commerciale 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0046_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0046_320x.jpg?v=1783086882"
      },
      {
        "title": "Commerciale 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0047_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0047_320x.jpg?v=1783086882"
      },
      {
        "title": "Commerciale 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0048_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0048_320x.jpg?v=1783086882"
      },
      {
        "title": "Commerciale 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0049_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0049_320x.jpg?v=1783086883"
      },
      {
        "title": "Commerciale 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0050_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0050_320x.jpg?v=1783086883"
      },
      {
        "title": "Commerciale 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0051_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0051_320x.jpg?v=1783086883"
      },
      {
        "title": "Commerciale 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0052_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0052_320x.jpg?v=1783086883"
      },
      {
        "title": "Commerciale 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0053_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0053_320x.jpg?v=1783086883"
      },
      {
        "title": "Commerciale 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0054_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0054_320x.jpg?v=1783086883"
      },
      {
        "title": "Commerciale 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0055_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0055_320x.jpg?v=1783086884"
      },
      {
        "title": "Commerciale 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0056_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0056_320x.jpg?v=1783086884"
      },
      {
        "title": "Commerciale 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0057_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0057_320x.jpg?v=1783086884"
      },
      {
        "title": "Commerciale 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0058_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0058_320x.jpg?v=1783086884"
      },
      {
        "title": "Commerciale 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0059_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0059_320x.jpg?v=1783086884"
      },
      {
        "title": "Commerciale 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0060_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0060_320x.jpg?v=1783086885"
      },
      {
        "title": "Commerciale 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0061_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0061_320x.jpg?v=1783086885"
      },
      {
        "title": "Commerciale 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0062_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0062_320x.jpg?v=1783086885"
      },
      {
        "title": "Commerciale 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0063_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0063_320x.jpg?v=1783086885"
      },
      {
        "title": "Commerciale 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0064_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0064_320x.jpg?v=1783086885"
      },
      {
        "title": "Commerciale 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0065_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0065_320x.jpg?v=1783086885"
      },
      {
        "title": "Commerciale 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0066_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0066_320x.jpg?v=1783086886"
      },
      {
        "title": "Commerciale 0067",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0067_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0067_320x.jpg?v=1783086886"
      },
      {
        "title": "Commerciale 0068",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0068_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0068_320x.jpg?v=1783086886"
      },
      {
        "title": "Commerciale 0069",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0069_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0069_320x.jpg?v=1783086886"
      },
      {
        "title": "Commerciale 0070",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0070_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-commerciale-0070_320x.jpg?v=1783086886"
      }
    ]
  },
  {
    "title": "Righe",
    "count": 35,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-righe_1600x.webp?v=1783086884",
    "items": [
      {
        "title": "Righe 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0001_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0001_320x.jpg?v=1783086887"
      },
      {
        "title": "Righe 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0002_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0002_320x.jpg?v=1783086887"
      },
      {
        "title": "Righe 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0003_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0003_320x.jpg?v=1783086887"
      },
      {
        "title": "Righe 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0004_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0004_320x.jpg?v=1783086887"
      },
      {
        "title": "Righe 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0005_1600x.jpg?v=1783086888",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0005_320x.jpg?v=1783086888"
      },
      {
        "title": "Righe 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0006_1600x.jpg?v=1783086887",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0006_320x.jpg?v=1783086887"
      },
      {
        "title": "Righe 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0007_1600x.jpg?v=1783086888",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0007_320x.jpg?v=1783086888"
      },
      {
        "title": "Righe 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0008_1600x.jpg?v=1783086888",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0008_320x.jpg?v=1783086888"
      },
      {
        "title": "Righe 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0009_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0009_320x.jpg?v=1783086872"
      },
      {
        "title": "Righe 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0010_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0010_320x.jpg?v=1783086872"
      },
      {
        "title": "Righe 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0011_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0011_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0012_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0012_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0013_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0013_320x.jpg?v=1783086872"
      },
      {
        "title": "Righe 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0014_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0014_320x.jpg?v=1783086872"
      },
      {
        "title": "Righe 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0015_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0015_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0016_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0016_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0017_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0017_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0018_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0018_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0019_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0019_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0020_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0020_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0021_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0021_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0022_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0022_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0023_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0023_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0024_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0024_320x.jpg?v=1783086873"
      },
      {
        "title": "Righe 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0025_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0025_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0026_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0026_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0027_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0027_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0028_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0028_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0029_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0029_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0030_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0030_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0031_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0031_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0032_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0032_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0033_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0033_320x.jpg?v=1783086874"
      },
      {
        "title": "Righe 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0034_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0034_320x.jpg?v=1783086875"
      },
      {
        "title": "Righe 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0035_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-righe-0035_320x.jpg?v=1783086875"
      }
    ]
  },
  {
    "title": "Floreale",
    "count": 80,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-floreale_1600x.webp?v=1783086872",
    "items": [
      {
        "title": "Floreale 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0001_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0001_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0002_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0002_320x.jpg?v=1783086875"
      },
      {
        "title": "Floreale 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0003_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0003_320x.jpg?v=1783086875"
      },
      {
        "title": "Floreale 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0004_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0004_320x.jpg?v=1783086875"
      },
      {
        "title": "Floreale 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0005_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0005_320x.jpg?v=1783086875"
      },
      {
        "title": "Floreale 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0006_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0006_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0007_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0007_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0008_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0008_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0009_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0009_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0010_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0010_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0011_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0011_320x.jpg?v=1783086877"
      },
      {
        "title": "Floreale 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0012_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0012_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0013_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0013_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0014_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0014_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0015_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0015_320x.jpg?v=1783086876"
      },
      {
        "title": "Floreale 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0016_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0016_320x.jpg?v=1783086877"
      },
      {
        "title": "Floreale 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0017_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0017_320x.jpg?v=1783086877"
      },
      {
        "title": "Floreale 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0018_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0018_320x.jpg?v=1783086877"
      },
      {
        "title": "Floreale 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0019_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0019_320x.jpg?v=1783086877"
      },
      {
        "title": "Floreale 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0020_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0020_320x.jpg?v=1783086877"
      },
      {
        "title": "Floreale 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0021_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0021_320x.jpg?v=1783086877"
      },
      {
        "title": "Floreale 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0022_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0022_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0023_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0023_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0024_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0024_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0025_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0025_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0026_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0026_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0027_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0027_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0028_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0028_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0029_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0029_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0030_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0030_320x.jpg?v=1783086878"
      },
      {
        "title": "Floreale 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0031_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0031_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0032_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0032_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0033_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0033_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0034_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0034_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0035_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0035_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0036_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0036_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0037_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0037_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0038_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0038_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0039_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0039_320x.jpg?v=1783086879"
      },
      {
        "title": "Floreale 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0040_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0040_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0041_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0041_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0042_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0042_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0043_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0043_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0044_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0044_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0045_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0045_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0046_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0046_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0047_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0047_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0048_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0048_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0049_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0049_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0050_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0050_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0051_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0051_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0052_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0052_320x.jpg?v=1783086880"
      },
      {
        "title": "Floreale 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0053_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0053_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0054_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0054_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0055_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0055_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0056_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0056_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0057_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0057_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0058_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0058_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0059_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0059_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0060_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0060_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0061_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0061_320x.jpg?v=1783086882"
      },
      {
        "title": "Floreale 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0062_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0062_320x.jpg?v=1783086881"
      },
      {
        "title": "Floreale 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0063_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0063_320x.jpg?v=1783086882"
      },
      {
        "title": "Floreale 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0064_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0064_320x.jpg?v=1783086882"
      },
      {
        "title": "Floreale 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0065_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0065_320x.jpg?v=1783086872"
      },
      {
        "title": "Floreale 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0066_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0066_320x.jpg?v=1783086872"
      },
      {
        "title": "Floreale 0067",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0067_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0067_320x.jpg?v=1783086872"
      },
      {
        "title": "Floreale 0068",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0068_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0068_320x.jpg?v=1783086873"
      },
      {
        "title": "Floreale 0069",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0069_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0069_320x.jpg?v=1783086873"
      },
      {
        "title": "Floreale 0070",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0070_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0070_320x.jpg?v=1783086873"
      },
      {
        "title": "Floreale 0071",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0071_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0071_320x.jpg?v=1783086873"
      },
      {
        "title": "Floreale 0072",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0072_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0072_320x.jpg?v=1783086873"
      },
      {
        "title": "Floreale 0073",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0073_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0073_320x.jpg?v=1783086873"
      },
      {
        "title": "Floreale 0074",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0074_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0074_320x.jpg?v=1783086873"
      },
      {
        "title": "Floreale 0075",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0075_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0075_320x.jpg?v=1783086874"
      },
      {
        "title": "Floreale 0076",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0076_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0076_320x.jpg?v=1783086874"
      },
      {
        "title": "Floreale 0077",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0077_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0077_320x.jpg?v=1783086874"
      },
      {
        "title": "Floreale 0078",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0078_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0078_320x.jpg?v=1783086874"
      },
      {
        "title": "Floreale 0079",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0079_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0079_320x.jpg?v=1783086874"
      },
      {
        "title": "Floreale 0080",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0080_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-floreale-0080_320x.jpg?v=1783086874"
      }
    ]
  },
  {
    "title": "Baby",
    "count": 60,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-baby_1600x.webp?v=1783086872",
    "items": [
      {
        "title": "Baby 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0001_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0001_320x.jpg?v=1783086875"
      },
      {
        "title": "Baby 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0002_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0002_320x.jpg?v=1783086875"
      },
      {
        "title": "Baby 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0003_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0003_320x.jpg?v=1783086875"
      },
      {
        "title": "Baby 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0004_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0004_320x.jpg?v=1783086875"
      },
      {
        "title": "Baby 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0005_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0005_320x.jpg?v=1783086875"
      },
      {
        "title": "Baby 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0006_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0006_320x.jpg?v=1783086875"
      },
      {
        "title": "Baby 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0007_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0007_320x.jpg?v=1783086876"
      },
      {
        "title": "Baby 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0008_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0008_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0009_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0009_320x.jpg?v=1783086876"
      },
      {
        "title": "Baby 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0010_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0010_320x.jpg?v=1783086876"
      },
      {
        "title": "Baby 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0011_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0011_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0012_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0012_320x.jpg?v=1783086876"
      },
      {
        "title": "Baby 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0013_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0013_320x.jpg?v=1783086876"
      },
      {
        "title": "Baby 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0014_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0014_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0015_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0015_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0016_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0016_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0017_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0017_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0018_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0018_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0019_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0019_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0020_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0020_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0021_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0021_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0022_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0022_320x.jpg?v=1783086877"
      },
      {
        "title": "Baby 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0023_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0023_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0024_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0024_320x.jpg?v=1783086879"
      },
      {
        "title": "Baby 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0025_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0025_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0026_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0026_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0027_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0027_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0028_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0028_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0029_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0029_320x.jpg?v=1783086878"
      },
      {
        "title": "Baby 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0030_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0030_320x.jpg?v=1783086879"
      },
      {
        "title": "Baby 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0031_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0031_320x.jpg?v=1783086879"
      },
      {
        "title": "Baby 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0032_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0032_320x.jpg?v=1783086879"
      },
      {
        "title": "Baby 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0033_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0033_320x.jpg?v=1783086879"
      },
      {
        "title": "Baby 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0034_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0034_320x.jpg?v=1783086879"
      },
      {
        "title": "Baby 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0035_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0035_320x.jpg?v=1783086880"
      },
      {
        "title": "Baby 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0036_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0036_320x.jpg?v=1783086880"
      },
      {
        "title": "Baby 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0037_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0037_320x.jpg?v=1783086880"
      },
      {
        "title": "Baby 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0038_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0038_320x.jpg?v=1783086880"
      },
      {
        "title": "Baby 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0039_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0039_320x.jpg?v=1783086880"
      },
      {
        "title": "Baby 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0040_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0040_320x.jpg?v=1783086880"
      },
      {
        "title": "Baby 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0041_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0041_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0042_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0042_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0043_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0043_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0044_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0044_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0045_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0045_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0046_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0046_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0047_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0047_320x.jpg?v=1783086882"
      },
      {
        "title": "Baby 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0048_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0048_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0049_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0049_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0050_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0050_320x.jpg?v=1783086881"
      },
      {
        "title": "Baby 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0051_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0051_320x.jpg?v=1783086882"
      },
      {
        "title": "Baby 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0052_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0052_320x.jpg?v=1783086882"
      },
      {
        "title": "Baby 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0053_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0053_320x.jpg?v=1783086882"
      },
      {
        "title": "Baby 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0054_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0054_320x.jpg?v=1783086882"
      },
      {
        "title": "Baby 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0055_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0055_320x.jpg?v=1783086882"
      },
      {
        "title": "Baby 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0056_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0056_320x.jpg?v=1783086883"
      },
      {
        "title": "Baby 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0057_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0057_320x.jpg?v=1783086883"
      },
      {
        "title": "Baby 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0058_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0058_320x.jpg?v=1783086883"
      },
      {
        "title": "Baby 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0059_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0059_320x.jpg?v=1783086883"
      },
      {
        "title": "Baby 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0060_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-baby-0060_320x.jpg?v=1783086883"
      }
    ]
  },
  {
    "title": "Bambini",
    "count": 150,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-bambini_1600x.webp?v=1783086881",
    "items": [
      {
        "title": "Bambini 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0001_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0001_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0002_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0002_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0003_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0003_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0004_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0004_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0005_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0005_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0006_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0006_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0007_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0007_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0008_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0008_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0009_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0009_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0010_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0010_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0011_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0011_320x.jpg?v=1783086885"
      },
      {
        "title": "Bambini 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0012_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0012_320x.jpg?v=1783086885"
      },
      {
        "title": "Bambini 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0013_1600x.jpg?v=1783086886",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0013_320x.jpg?v=1783086886"
      },
      {
        "title": "Bambini 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0014_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0014_320x.jpg?v=1783086885"
      },
      {
        "title": "Bambini 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0015_1600x.jpg?v=1783086871",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0015_320x.jpg?v=1783086871"
      },
      {
        "title": "Bambini 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0016_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0016_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0017_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0017_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0018_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0018_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0019_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0019_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0020_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0020_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0021_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0021_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0022_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0022_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0023_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0023_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0024_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0024_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0025_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0025_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0026_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0026_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0027_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0027_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0028_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0028_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0029_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0029_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0030_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0030_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0031_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0031_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0032_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0032_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0033_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0033_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0034_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0034_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0035_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0035_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0036_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0036_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0037_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0037_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0038_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0038_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0039_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0039_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0040_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0040_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0041_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0041_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0042_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0042_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0043_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0043_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0044_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0044_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0045_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0045_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0046_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0046_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0047_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0047_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0048_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0048_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0049_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0049_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0050_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0050_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0051_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0051_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0052_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0052_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0053_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0053_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0054_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0054_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0055_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0055_320x.jpg?v=1783086878"
      },
      {
        "title": "Bambini 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0056_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0056_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0057_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0057_320x.jpg?v=1783086878"
      },
      {
        "title": "Bambini 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0058_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0058_320x.jpg?v=1783086878"
      },
      {
        "title": "Bambini 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0059_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0059_320x.jpg?v=1783086878"
      },
      {
        "title": "Bambini 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0060_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0060_320x.jpg?v=1783086878"
      },
      {
        "title": "Bambini 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0061_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0061_320x.jpg?v=1783086878"
      },
      {
        "title": "Bambini 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0062_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0062_320x.jpg?v=1783086878"
      },
      {
        "title": "Bambini 0063",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0063_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0063_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0064",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0064_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0064_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0065",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0065_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0065_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0066",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0066_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0066_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0067",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0067_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0067_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0068",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0068_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0068_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0069",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0069_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0069_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0070",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0070_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0070_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0071",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0071_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0071_320x.jpg?v=1783086880"
      },
      {
        "title": "Bambini 0072",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0072_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0072_320x.jpg?v=1783086879"
      },
      {
        "title": "Bambini 0073",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0073_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0073_320x.jpg?v=1783086880"
      },
      {
        "title": "Bambini 0074",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0074_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0074_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0075",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0075_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0075_320x.jpg?v=1783086880"
      },
      {
        "title": "Bambini 0076",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0076_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0076_320x.jpg?v=1783086880"
      },
      {
        "title": "Bambini 0077",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0077_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0077_320x.jpg?v=1783086881"
      },
      {
        "title": "Bambini 0078",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0078_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0078_320x.jpg?v=1783086880"
      },
      {
        "title": "Bambini 0079",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0079_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0079_320x.jpg?v=1783086881"
      },
      {
        "title": "Bambini 0080",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0080_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0080_320x.jpg?v=1783086881"
      },
      {
        "title": "Bambini 0081",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0081_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0081_320x.jpg?v=1783086881"
      },
      {
        "title": "Bambini 0082",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0082_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0082_320x.jpg?v=1783086881"
      },
      {
        "title": "Bambini 0083",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0083_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0083_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0084",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0084_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0084_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0085",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0085_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0085_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0086",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0086_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0086_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0087",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0087_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0087_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0088",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0088_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0088_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0089",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0089_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0089_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0090",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0090_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0090_320x.jpg?v=1783086882"
      },
      {
        "title": "Bambini 0091",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0091_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0091_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0092",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0092_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0092_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0093",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0093_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0093_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0094",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0094_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0094_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0095",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0095_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0095_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0096",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0096_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0096_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0097",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0097_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0097_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0098",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0098_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0098_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0099",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0099_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0099_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0100",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0100_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0100_320x.jpg?v=1783086883"
      },
      {
        "title": "Bambini 0101",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0101_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0101_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0102",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0102_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0102_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0103",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0103_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0103_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0104",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0104_1600x.jpg?v=1783086884",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0104_320x.jpg?v=1783086884"
      },
      {
        "title": "Bambini 0105",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0105_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0105_320x.jpg?v=1783086885"
      },
      {
        "title": "Bambini 0106",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0106_1600x.jpg?v=1783086885",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0106_320x.jpg?v=1783086885"
      },
      {
        "title": "Bambini 0107",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0107_1600x.jpg?v=1783086871",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0107_320x.jpg?v=1783086871"
      },
      {
        "title": "Bambini 0108",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0108_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0108_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0109",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0109_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0109_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0110",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0110_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0110_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0111",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0111_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0111_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0112",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0112_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0112_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0113",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0113_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0113_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0114",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0114_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0114_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0115",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0115_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0115_320x.jpg?v=1783086872"
      },
      {
        "title": "Bambini 0116",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0116_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0116_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0117",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0117_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0117_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0118",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0118_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0118_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0119",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0119_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0119_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0120",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0120_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0120_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0121",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0121_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0121_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0122",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0122_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0122_320x.jpg?v=1783086873"
      },
      {
        "title": "Bambini 0123",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0123_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0123_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0124",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0124_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0124_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0125",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0125_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0125_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0126",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0126_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0126_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0127",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0127_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0127_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0128",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0128_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0128_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0129",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0129_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0129_320x.jpg?v=1783086874"
      },
      {
        "title": "Bambini 0130",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0130_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0130_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0131",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0131_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0131_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0132",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0132_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0132_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0133",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0133_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0133_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0134",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0134_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0134_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0135",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0135_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0135_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0136",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0136_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0136_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0137",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0137_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0137_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0138",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0138_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0138_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0139",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0139_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0139_320x.jpg?v=1783086875"
      },
      {
        "title": "Bambini 0140",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0140_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0140_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0141",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0141_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0141_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0142",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0142_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0142_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0143",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0143_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0143_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0144",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0144_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0144_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0145",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0145_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0145_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0146",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0146_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0146_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0147",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0147_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0147_320x.jpg?v=1783086876"
      },
      {
        "title": "Bambini 0148",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0148_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0148_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0149",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0149_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0149_320x.jpg?v=1783086877"
      },
      {
        "title": "Bambini 0150",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0150_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-bambini-0150_320x.jpg?v=1783086877"
      }
    ]
  },
  {
    "title": "Paesaggi",
    "count": 62,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-paesaggi_1600x.webp?v=1783086874",
    "items": [
      {
        "title": "Paesaggi 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0001_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0001_320x.jpg?v=1783086877"
      },
      {
        "title": "Paesaggi 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0002_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0002_320x.jpg?v=1783086877"
      },
      {
        "title": "Paesaggi 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0003_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0003_320x.jpg?v=1783086877"
      },
      {
        "title": "Paesaggi 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0004_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0004_320x.jpg?v=1783086877"
      },
      {
        "title": "Paesaggi 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0005_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0005_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0006_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0006_320x.jpg?v=1783086877"
      },
      {
        "title": "Paesaggi 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0007_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0007_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0008_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0008_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0009_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0009_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0010_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0010_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0011_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0011_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0012_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0012_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0013_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0013_320x.jpg?v=1783086878"
      },
      {
        "title": "Paesaggi 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0014_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0014_320x.jpg?v=1783086879"
      },
      {
        "title": "Paesaggi 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0015_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0015_320x.jpg?v=1783086879"
      },
      {
        "title": "Paesaggi 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0016_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0016_320x.jpg?v=1783086879"
      },
      {
        "title": "Paesaggi 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0017_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0017_320x.jpg?v=1783086879"
      },
      {
        "title": "Paesaggi 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0018_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0018_320x.jpg?v=1783086879"
      },
      {
        "title": "Paesaggi 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0019_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0019_320x.jpg?v=1783086879"
      },
      {
        "title": "Paesaggi 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0020_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0020_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0021_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0021_320x.jpg?v=1783086879"
      },
      {
        "title": "Paesaggi 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0022_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0022_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0023_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0023_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0024_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0024_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0025_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0025_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0026_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0026_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0027_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0027_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0028_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0028_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0029_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0029_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0030_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0030_320x.jpg?v=1783086880"
      },
      {
        "title": "Paesaggi 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0031_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0031_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0032_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0032_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0033_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0033_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0034_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0034_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0035_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0035_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0036_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0036_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0037_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0037_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0038_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0038_320x.jpg?v=1783086882"
      },
      {
        "title": "Paesaggi 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0039_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0039_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0040_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0040_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0041_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0041_320x.jpg?v=1783086881"
      },
      {
        "title": "Paesaggi 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0042_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0042_320x.jpg?v=1783086882"
      },
      {
        "title": "Paesaggi 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0043_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0043_320x.jpg?v=1783086882"
      },
      {
        "title": "Paesaggi 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0044_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0044_320x.jpg?v=1783086882"
      },
      {
        "title": "Paesaggi 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0045_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0045_320x.jpg?v=1783086883"
      },
      {
        "title": "Paesaggi 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0046_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0046_320x.jpg?v=1783086882"
      },
      {
        "title": "Paesaggi 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0047_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0047_320x.jpg?v=1783086883"
      },
      {
        "title": "Paesaggi 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0048_1600x.jpg?v=1783086871",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0048_320x.jpg?v=1783086871"
      },
      {
        "title": "Paesaggi 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0049_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0049_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0050_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0050_320x.jpg?v=1783086872"
      },
      {
        "title": "Paesaggi 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0051_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0051_320x.jpg?v=1783086872"
      },
      {
        "title": "Paesaggi 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0052_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0052_320x.jpg?v=1783086872"
      },
      {
        "title": "Paesaggi 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0053_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0053_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0054_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0054_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0055",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0055_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0055_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0056",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0056_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0056_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0057",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0057_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0057_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0058",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0058_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0058_320x.jpg?v=1783086874"
      },
      {
        "title": "Paesaggi 0059",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0059_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0059_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0060",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0060_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0060_320x.jpg?v=1783086874"
      },
      {
        "title": "Paesaggi 0061",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0061_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0061_320x.jpg?v=1783086873"
      },
      {
        "title": "Paesaggi 0062",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0062_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-paesaggi-0062_320x.jpg?v=1783086874"
      }
    ]
  },
  {
    "title": "Foglie",
    "count": 54,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-foglie_1600x.webp?v=1783086871",
    "items": [
      {
        "title": "Foglie 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0001_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0001_320x.jpg?v=1783086874"
      },
      {
        "title": "Foglie 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0002_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0002_320x.jpg?v=1783086874"
      },
      {
        "title": "Foglie 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0003_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0003_320x.jpg?v=1783086874"
      },
      {
        "title": "Foglie 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0004_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0004_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0005_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0005_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0006_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0006_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0007_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0007_320x.jpg?v=1783086874"
      },
      {
        "title": "Foglie 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0008_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0008_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0009_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0009_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0010_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0010_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0011_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0011_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0012_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0012_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0013_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0013_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0014_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0014_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0015_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0015_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0016_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0016_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0017_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0017_320x.jpg?v=1783086875"
      },
      {
        "title": "Foglie 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0018_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0018_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0019_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0019_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0020_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0020_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0021_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0021_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0022_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0022_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0023_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0023_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0024_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0024_320x.jpg?v=1783086876"
      },
      {
        "title": "Foglie 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0025_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0025_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0026_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0026_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0027_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0027_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0028_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0028_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0029_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0029_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0030_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0030_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0031_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0031_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0032_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0032_320x.jpg?v=1783086877"
      },
      {
        "title": "Foglie 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0033_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0033_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0034_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0034_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0035_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0035_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0036_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0036_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0037_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0037_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0038_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0038_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0039_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0039_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0040_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0040_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0041_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0041_320x.jpg?v=1783086878"
      },
      {
        "title": "Foglie 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0042_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0042_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0043_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0043_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0044_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0044_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0045",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0045_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0045_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0046",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0046_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0046_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0047",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0047_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0047_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0048",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0048_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0048_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0049",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0049_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0049_320x.jpg?v=1783086880"
      },
      {
        "title": "Foglie 0050",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0050_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0050_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0051",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0051_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0051_320x.jpg?v=1783086880"
      },
      {
        "title": "Foglie 0052",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0052_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0052_320x.jpg?v=1783086879"
      },
      {
        "title": "Foglie 0053",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0053_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0053_320x.jpg?v=1783086880"
      },
      {
        "title": "Foglie 0054",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0054_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-foglie-0054_320x.jpg?v=1783086880"
      }
    ]
  },
  {
    "title": "Marmo",
    "count": 38,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-marmo_1600x.webp?v=1783086877",
    "items": [
      {
        "title": "Marmo 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0001_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0001_320x.jpg?v=1783086881"
      },
      {
        "title": "Marmo 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0002_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0002_320x.jpg?v=1783086881"
      },
      {
        "title": "Marmo 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0003_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0003_320x.jpg?v=1783086881"
      },
      {
        "title": "Marmo 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0004_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0004_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0005_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0005_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0006_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0006_320x.jpg?v=1783086881"
      },
      {
        "title": "Marmo 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0007_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0007_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0008_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0008_320x.jpg?v=1783086881"
      },
      {
        "title": "Marmo 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0009_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0009_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0010_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0010_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0011_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0011_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0012_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0012_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0013_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0013_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0014_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0014_320x.jpg?v=1783086883"
      },
      {
        "title": "Marmo 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0015_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0015_320x.jpg?v=1783086882"
      },
      {
        "title": "Marmo 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0016_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0016_320x.jpg?v=1783086883"
      },
      {
        "title": "Marmo 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0017_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0017_320x.jpg?v=1783086883"
      },
      {
        "title": "Marmo 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0018_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0018_320x.jpg?v=1783086883"
      },
      {
        "title": "Marmo 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0019_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0019_320x.jpg?v=1783086883"
      },
      {
        "title": "Marmo 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0020_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0020_320x.jpg?v=1783086883"
      },
      {
        "title": "Marmo 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0021_1600x.jpg?v=1783086883",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0021_320x.jpg?v=1783086883"
      },
      {
        "title": "Marmo 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0022_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0022_320x.jpg?v=1783086872"
      },
      {
        "title": "Marmo 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0023_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0023_320x.jpg?v=1783086873"
      },
      {
        "title": "Marmo 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0024_1600x.jpg?v=1783086872",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0024_320x.jpg?v=1783086872"
      },
      {
        "title": "Marmo 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0025_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0025_320x.jpg?v=1783086873"
      },
      {
        "title": "Marmo 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0026_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0026_320x.jpg?v=1783086873"
      },
      {
        "title": "Marmo 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0027_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0027_320x.jpg?v=1783086873"
      },
      {
        "title": "Marmo 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0028_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0028_320x.jpg?v=1783086874"
      },
      {
        "title": "Marmo 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0029_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0029_320x.jpg?v=1783086873"
      },
      {
        "title": "Marmo 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0030_1600x.jpg?v=1783086873",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0030_320x.jpg?v=1783086873"
      },
      {
        "title": "Marmo 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0031_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0031_320x.jpg?v=1783086874"
      },
      {
        "title": "Marmo 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0032_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0032_320x.jpg?v=1783086874"
      },
      {
        "title": "Marmo 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0033_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0033_320x.jpg?v=1783086874"
      },
      {
        "title": "Marmo 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0034_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0034_320x.jpg?v=1783086874"
      },
      {
        "title": "Marmo 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0035_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0035_320x.jpg?v=1783086875"
      },
      {
        "title": "Marmo 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0036_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0036_320x.jpg?v=1783086874"
      },
      {
        "title": "Marmo 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0037_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0037_320x.jpg?v=1783086874"
      },
      {
        "title": "Marmo 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0038_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-marmo-0038_320x.jpg?v=1783086874"
      }
    ]
  },
  {
    "title": "Artistico",
    "count": 24,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-artistico_1600x.webp?v=1783086871",
    "items": [
      {
        "title": "Artistico 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0001_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0001_320x.jpg?v=1783086874"
      },
      {
        "title": "Artistico 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0002_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0002_320x.jpg?v=1783086874"
      },
      {
        "title": "Artistico 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0003_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0003_320x.jpg?v=1783086874"
      },
      {
        "title": "Artistico 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0004_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0004_320x.jpg?v=1783086874"
      },
      {
        "title": "Artistico 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0005_1600x.jpg?v=1783086874",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0005_320x.jpg?v=1783086874"
      },
      {
        "title": "Artistico 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0006_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0006_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0007_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0007_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0008_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0008_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0009_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0009_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0010_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0010_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0011_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0011_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0012_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0012_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0013_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0013_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0014_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0014_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0015_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0015_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0016_1600x.jpg?v=1783086875",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0016_320x.jpg?v=1783086875"
      },
      {
        "title": "Artistico 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0017_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0017_320x.jpg?v=1783086876"
      },
      {
        "title": "Artistico 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0018_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0018_320x.jpg?v=1783086876"
      },
      {
        "title": "Artistico 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0019_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0019_320x.jpg?v=1783086876"
      },
      {
        "title": "Artistico 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0020_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0020_320x.jpg?v=1783086876"
      },
      {
        "title": "Artistico 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0021_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0021_320x.jpg?v=1783086876"
      },
      {
        "title": "Artistico 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0022_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0022_320x.jpg?v=1783086876"
      },
      {
        "title": "Artistico 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0023_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0023_320x.jpg?v=1783086877"
      },
      {
        "title": "Artistico 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0024_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-artistico-0024_320x.jpg?v=1783086877"
      }
    ]
  },
  {
    "title": "Render",
    "count": 44,
    "cover": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-cover-render_1600x.webp?v=1783086874",
    "items": [
      {
        "title": "Render 0001",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0001_1600x.jpg?v=1783086876",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0001_320x.jpg?v=1783086876"
      },
      {
        "title": "Render 0002",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0002_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0002_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0003",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0003_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0003_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0004",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0004_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0004_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0005",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0005_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0005_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0006",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0006_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0006_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0007",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0007_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0007_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0008",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0008_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0008_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0009",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0009_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0009_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0010",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0010_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0010_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0011",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0011_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0011_320x.jpg?v=1783086878"
      },
      {
        "title": "Render 0012",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0012_1600x.jpg?v=1783086877",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0012_320x.jpg?v=1783086877"
      },
      {
        "title": "Render 0013",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0013_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0013_320x.jpg?v=1783086878"
      },
      {
        "title": "Render 0014",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0014_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0014_320x.jpg?v=1783086878"
      },
      {
        "title": "Render 0015",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0015_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0015_320x.jpg?v=1783086878"
      },
      {
        "title": "Render 0016",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0016_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0016_320x.jpg?v=1783086878"
      },
      {
        "title": "Render 0017",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0017_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0017_320x.jpg?v=1783086878"
      },
      {
        "title": "Render 0018",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0018_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0018_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0019",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0019_1600x.jpg?v=1783086878",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0019_320x.jpg?v=1783086878"
      },
      {
        "title": "Render 0020",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0020_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0020_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0021",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0021_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0021_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0022",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0022_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0022_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0023",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0023_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0023_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0024",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0024_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0024_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0025",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0025_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0025_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0026",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0026_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0026_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0027",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0027_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0027_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0028",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0028_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0028_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0029",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0029_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0029_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0030",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0030_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0030_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0031",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0031_1600x.jpg?v=1783086879",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0031_320x.jpg?v=1783086879"
      },
      {
        "title": "Render 0032",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0032_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0032_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0033",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0033_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0033_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0034",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0034_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0034_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0035",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0035_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0035_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0036",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0036_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0036_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0037",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0037_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0037_320x.jpg?v=1783086881"
      },
      {
        "title": "Render 0038",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0038_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0038_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0039",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0039_1600x.jpg?v=1783086880",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0039_320x.jpg?v=1783086880"
      },
      {
        "title": "Render 0040",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0040_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0040_320x.jpg?v=1783086881"
      },
      {
        "title": "Render 0041",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0041_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0041_320x.jpg?v=1783086881"
      },
      {
        "title": "Render 0042",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0042_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0042_320x.jpg?v=1783086881"
      },
      {
        "title": "Render 0043",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0043_1600x.jpg?v=1783086882",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0043_320x.jpg?v=1783086882"
      },
      {
        "title": "Render 0044",
        "preview": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0044_1600x.jpg?v=1783086881",
        "thumb": "https://cdn.shopify.com/s/files/1/0694/1648/5132/files/zippo-pareti-render-0044_320x.jpg?v=1783086881"
      }
    ]
  }
];
